import React from 'react';
import {connect} from 'react-redux';
import Lineup from 'components/organisms/lineup';
import {BaseLineupsList} from './base-lineups-list';
import {scrollToLineup} from 'helpers/lineup-helper';

class DesktopLineupsList extends BaseLineupsList {
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {swappedPlayers: prevSwappedPlayers} = prevProps;
        const {swappedPlayers} = this.props;

        if (!prevSwappedPlayers.isSwappedPlayersQuantityEqual(swappedPlayers)) {
            scrollToLineup(swappedPlayers.getLastUpdatedLineupId());
        }
    }

    render() {
        const {status} = this.props;

        let content = this.getLineupsNotFoundView();

        const lineupsToRender = this.getLineupsToRender();

        if (!isEmpty(lineupsToRender)) {
            const lineups = lineupsToRender.map((lineup, i) => <Lineup key={i} lineupId={lineup.lineupId} index={i} />);

            content = this.getLineupsListView(lineups);
        }

        return <div className={status.isFilled ? 'results-content' : 'results-content loading'}>{content}</div>;
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups, status, filters},
        filterLineupsByPlayer,
        filterLineupsByTeamCombinations,
        filterLineupsByCorrelationStackCombinations,
        filterLineupsByKeyPlayerStackCombinations,
        swappedPlayers,
    } = state;

    return {
        lineups,
        status,
        filters,
        filterLineupsByPlayer,
        filterLineupsByTeamCombinations,
        filterLineupsByCorrelationStackCombinations,
        filterLineupsByKeyPlayerStackCombinations,
        swappedPlayers,
    };
}

const DesktopLineupsListComponent = connect(mapStatesToProps)(DesktopLineupsList);

export {DesktopLineupsListComponent};
